export default __webpack_public_path__ + "static/media/Group 7.0ff3a695.png";